import request from './adminRequest'

const roleApi = {
  createRole (data) {
    return request.post('/roles', data)
  },
  updateRole (data) {
    return request.put('/roles', data)
  },
  deleteRole (id) {
    return request.delete('/roles/' + id)
  },
  listRoles () {
    return request.get('/roles')
  },
  getRole (id) {
    return request.get('/roles/' + id)
  },
  listRolePermissions (id) {
    return request.get('/roles/' + id + '/permissions')
  },
  assignPermissions (data) {
    return request.post('/roles/assignPermissions', data)
  },
  assignAllPermissions (data) {
    return request.post('/roles/assignAllPermissions', data)
  },
  deleteRolePermission (id) {
    return request.delete('/roles/deleteRolePermission/' + id)
  },
  listRoleEmployees (id) {
    return request.get('/' + id + '/employees')
  },
  assignEmployees (data) {
    return request.post('/roles/assignEmployees', data)
  },
  deleteRoleEmployee (id) {
    return request.delete('/roles/deleteRoleEmployee/' + id)
  },
}

export default roleApi
